import { Button } from "antd";
import { useEffect, useState } from "react";
import WithPermission from "../components/misc/WithPermission";
import ManageStaff from "../components/staffs/ManageStaff";
import StaffList from "../components/staffs/StaffList";
import { Staff } from "../entities/interfaces/staffs";
import StaffService from "../services/staffs.service";

const Staffs = () => {
  const [staffs, setStaffs] = useState<Staff[]>([]);
  const [manageStaffModal, setManageStaffModal] = useState(false);
  const [selected, setSelected] = useState<Staff | undefined>();

  useEffect(() => {
    getStaffs();
  }, []);

  const getStaffs = async () => {
    const res = await StaffService.list({});
    if (!res?.success) return;
    setStaffs(res.data);
  };

  const openManageStaffModal = () => {
    setManageStaffModal(true);
  };

  const closeManageStaffModal = () => {
    if (selected) {
      setSelected(undefined);
    }
    setManageStaffModal(false);
  };

  return (
    <div>
      <div className="flex justify-between">
        <div className="mb-5">
          <h1 className="text-xl font-bold">Staffs</h1>
          <p>Manage your organisation staffs</p>
        </div>
        <WithPermission permission="create:staffs">
          <Button type="primary" onClick={openManageStaffModal}>
            Create Staff
          </Button>
        </WithPermission>

        <ManageStaff
          open={manageStaffModal}
          onChange={getStaffs}
          onClose={closeManageStaffModal}
          selected={selected}
        />
      </div>
      <StaffList
        staffs={staffs}
        onSelect={(data) => {
          openManageStaffModal();
          setSelected(data);
        }}
      />
    </div>
  );
};

export default Staffs;
